export default ($resource) => {
    const baseUrl = `${SEED_CORE.ENV.API_URL}course/occurrence-file`;
    const url = `${baseUrl}/:id`;
    return $resource(url, null, {
        get: {
            method: 'GET',
            url: baseUrl,
            isArray: true
        },
        update: {
            method: 'PUT',
            url
        }
    });
};



// WEBPACK FOOTER //
// ./src/app/resources/OccurrenceFile/index.js